var path = '/var/www/mmscny-website/src/app/common/components/page-content-count/page-content-count.html';
var html = "<span> {{ $ctrl.currentTotalItems }} of {{ $ctrl.totalItems }} </span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/page-content-count/page-content-count.html
// module id = 654
// module chunks = 0